import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/simp_in/step1';
import { Oui } from '../models/Oui';
@Component({
	selector: 'app-oui',
	templateUrl: './oui.component.html'
})
export class OuiComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Oui';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() oui: Oui;

	public step1 = new Step1();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
